import { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import useSocket from 'tennders-common/hooks/useSocket'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { GButton } from 'tennders-common/form/components'
import GDatePicker from 'tennders-common/form/components/date'
import GModal from 'tennders-market/common/components/element/GModal'
import { useToast } from 'tennders-common/hooks/useToast'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchETS } from 'tennders-common/stores/modal/action'

interface ETDForm {
  departureDate ?: Date,
  departureTime ?: Date,
  arrivalDate ?: Date,
  arrivalTime ?: Date
}

const MEDTUpdate = (props) => {
  const { toastSuccess } = useToast()
  const { setRefresh } = useSocket()
  const transaction = useSelector((state:StateType) => state.modal.ets)
  const dispatch = useDispatch()
  const [form, setform] = useState<ETDForm>({
    arrivalDate: transaction?.matchedLoad?.etdDelivery ? new Date(transaction?.matchedLoad?.etdDelivery) : null,
    arrivalTime: transaction?.matchedLoad?.etdDelivery ? new Date(transaction?.matchedLoad?.etdDelivery) : null,
    departureDate: transaction?.matchedLoad?.etdPickup ? new Date(transaction?.matchedLoad?.etdPickup) : null,
    departureTime: transaction?.matchedLoad?.etdPickup ? new Date(transaction?.matchedLoad?.etdPickup) : null
  })
  const { t } = useTranslation()
  const { editTransaction } = useTransactions()
  const [submitting, setsubmitting] = useState(false)

  const onChange = (k, v) => setform({ ...form, [k]: v })

  const close = () => {
    dispatch(dispatchETS(null))
  }

  const send = async () => {
    setsubmitting(true)
    await editTransaction(transaction?.id, { ...form })
    setsubmitting(false)
    toastSuccess(t('toast:savedSuccessfully'))
    close()
    setRefresh('all')
  }

  useEffect(() => {
    if (transaction) {
      setform({
        arrivalDate: transaction?.matchedLoad?.etdDelivery ? new Date(transaction?.matchedLoad?.etdDelivery) : null,
        arrivalTime: transaction?.matchedLoad?.etdDelivery ? new Date(transaction?.matchedLoad?.etdDelivery) : null,
        departureDate: transaction?.matchedLoad?.etdPickup ? new Date(transaction?.matchedLoad?.etdPickup) : null,
        departureTime: transaction?.matchedLoad?.etdPickup ? new Date(transaction?.matchedLoad?.etdPickup) : null
      })
    }
  }, [transaction])

  return (
    <GModal
      size={400}
      close={close}
      isOpen={!!transaction}
      {...props}
    >
      <div className="tennders-modal-body w-100">
        <h3 className="bold">{t('tableRow:ets')}</h3>
        <h4 className="mt-10">{t('modal:estimatedTimeOfArrival')}</h4>
        <div className="d-flex row" style={{ flexFlow: 'nowrap', gap: '8px' }}>
          <GDatePicker
            name="arrivalDate"
            form={form}
            single
            onChange={onChange}
            placeholder="DD/MM/YYYY"
          />
          <GDatePicker
            name="arrivalTime"
            form={form}
            timePicker
            onChange={onChange}
            placeholder="HH:MM"
            eClass=" "
          />
        </div><br />
        <h5>{t('modal:estimatedTimeOfDeparture')}</h5>
        <div className="d-flex row" style={{ flexFlow: 'nowrap', gap: '8px' }}>
          <GDatePicker
            name="departureDate"
            form={form}
            single
            onChange={onChange}
            placeholder="DD/MM/YYYY"
          />
          <GDatePicker
            name="departureTime"
            form={form}
            timePicker
            onChange={onChange}
            placeholder="HH:MM"
            eClass=" "
          />
        </div>
        {' '}
        <GButton
          disabled={!form?.departureDate && !form?.arrivalDate}
          submitting={submitting}
          className="btn standard-btn btn-w-icon bold mt-20 mb-2 w-100 flex-center"
          onClick={send}
          label={t('common:save')}
        />
      </div>
    </GModal>
  )
}

export default MEDTUpdate
